import { Button, ButtonGroup } from "@chakra-ui/react"
import { BsFileText } from "react-icons/bs"
import { itemData, AL_INFO, useSelectedItemAlertContext } from "../../context/selectedItemAlertContext"

const TableButtonAdminQueueGroup = ({ row, size = "xs" }) => {
    const { setItemData } = useSelectedItemAlertContext()

    const eventHandle = (id, type) => {
        setItemData(itemData(id, type))
    }

    return (
        <ButtonGroup spacing={2} size={size}>
            <Button leftIcon={<BsFileText />} colorScheme="orange" onClick={() => eventHandle(row.id, AL_INFO)} >ข้อมูล</Button>
        </ButtonGroup>
    )
}

export default TableButtonAdminQueueGroup